import React from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";

const RadioButtons = props => (
  <Form.Group inline>
    <label>
      {props.label}
      <span className="requiredAsterisk"> *</span>
    </label>
    {props.options.map(option => (
      <Form.Radio
        checked={props.value === option}
        label={option}
        name={props.name}
        onChange={props.changeHandler}
        value={option}
      />
    ))}
  </Form.Group>
);

RadioButtons.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  changeHandler: PropTypes.func.isRequired
};

export default RadioButtons;
